<template>
  <div class="flex-container" v-if="Object.keys(item).length">
    <div class="quote-detail">
      <h1>{{ item.name }}</h1>
      <p>{{ item.thName }}</p>
    </div>
    <div class="quote-price">
      <div class="h2">{{ item.price | parseNumberFormat }}</div>
      <span>
        <i class="fal fa-clock"></i>
        {{ item.date }}
      </span>
    </div>
    <div class="performance-a-year">
      <h3>ผลตอบแทน 1 ปี</h3>
      <p class="green" v-if="isYearPerfNegative !== true  && !perfNaN">
        {{ performanceYearPercentage }}
        <i class="fa fa-angle-up" aria-hidden="true"></i>
      </p>
      <p class="red" v-else-if="isYearPerfNegative && !perfNaN">
        {{ performanceYearPercentage }}
        <i class="fa fa-angle-down" aria-hidden="true"></i>
      </p>
      <p class="grey" v-else>{{ performanceYearPercentage }}</p>
    </div>
    <div class="intro-subscriber">
      <flex-card
        v-if="templateShare && hasShare && this.$route.name == 'miniapp-stock-quote'"
        :templateFlex="templateShare.template"
        :isPrepareCompleted="templateShare && templateShare.template ? isPrepareCompleted : false"
        @reset-fact="resetFact"
        class="share-assets"
      >
        <a slot="button" :data-action="'share_'+type" @click="generateShareTemplate">
          <i class="no-event fas fa-share-alt"></i>
        </a>
      </flex-card>

      <download-assets
        v-if="false && this.item && this.item.name && this.$route.name == 'miniapp-stock-quote'"
        class="download-assets"
        :dataType="type"
        :name="this.item.name"
      />

      <a href="javascript:;" class="subscribe-btn">
        <i class="fas fa-spinner-third fa-spin" v-if="loadingWatchlist"></i>
        <i
          v-else
          :data-action="dataAction"
          :class="[isFollowing ? 'fas fa-star following' : 'fas fa-star']"
          @click="addWatchlist()"
        ></i>
      </a>
    </div>
    <toast
      v-if="toggleToast"
      :toggleToast="toggleToast"
      :status="toastStatus"
      :toastType="toastType"
      :options="options"
      @close-toast="closeToast"
    ></toast>
  </div>
  <!-- Search Loading -->
  <div class="search-loading" v-else>
    <i class="loading fas fa-spinner-third fa-spin"></i>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex"
import Toast from "../../../components/miniapp/global/Toast.vue"
import FlexCard from "../../../components/miniapp/share/FlexCard.vue"
import DownloadAssets from "../../../components/miniapp/chatbot/DownloadAssets.vue"
import StockQuoteTemplate from "../../../../public/config/share/stock-quote-template.json"
import IndiceQuoteTemplate from "../../../../public/config/share/indice-quote-template.json"
import CarryActionAfterLogin from "../../../components/mixins/carry-action-after-login"
export default {
  components: {
    Toast,
    DownloadAssets,
    FlexCard
  },
  mixins: [CarryActionAfterLogin],
  props: {
    type: {
      type: String
    },
    item: {
      // type: Object
    },
    performanceValue: {
      type: String,
      default: "0.00 %"
    },
    isNegative: {
      type: Boolean,
      default: false
    },
    dataAction: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      colorPlus: "#2FAE55",
      colorMinus: "#da1616",
      templateShare: {
        template: null
      },
      loadingWatchlist: false,
      isPrepareCompleted: false,
      options: {
        dialog: {
          title: "เลิกติดตาม",
          body: "ต้องการเลิกติดตาม",
          action: [
            {
              action1: "ใช่",
              action2: "ไม่ใช่"
            }
          ]
        },
        toast: {
          duration: 2
        }
      },
      toggleToast: false,
      toastType: null,
      toastStatus: false,
      isFollowing: false,
    }
  },
  filters: {
    filterurrency(price) {
      const amt = Number(price)
      return (amt && amt.toLocaleString(undefined, { maximumFractionDigits: 2 })) || "0"
    },
    parseNumberFormat(num) {
      if (num) {
        return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      }
      return "0"
    }
  },
  watch: {
    async item() {
      await this.doWatchListProcess()
    },
  },
  computed: {
    ...mapGetters("watchlist", ["getAllStockWatchlist"]),
    ...mapGetters("auth", ["getIslogin"]),
    ...mapGetters("stock", ["getStockShareToFriend", "getStockNav1D", "getStockTimestamp1D"]),
    ...mapGetters("indice", ["getIndiceShareToFriend", "getIndiceQuote", "getIndiceTimestamp1D"]),
    hasShare() {
      return process.env.VUE_APP_CONFIG_SHARE_LINK === "true"
    },
    arrGraphData() {
      if (this.type == "stock") {
        return this.getStockNav1D
      } else  {
        return null
      }
    },
    perfPerPeriod() {
      if (this.arrGraphData && this.arrGraphData.length > 0) {
        let firstObj = this.arrGraphData[0]
        let lastObj = this.arrGraphData[this.arrGraphData.length - 1]
        let diffVal = parseFloat(lastObj.value) - parseFloat(firstObj.value)
        let diffValToFixed = diffVal.toFixed(4)

        let parts = diffValToFixed.toString().split(".")
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        let diffValFormat = parts.join(".")

        if (diffValFormat) {
          return diffValFormat
        }
      }
      return 0
    },
    perfPerPeriodPercent() {
      if (this.arrGraphData && this.arrGraphData.length > 0) {
        let firstObj = this.arrGraphData[0]
        let lastObj = this.arrGraphData[this.arrGraphData.length - 1]
        let firstVal = parseFloat(firstObj.value)
        let lastVal = parseFloat(lastObj.value)

        let diffVal = lastVal - firstVal
        let diffValPercent = (diffVal / firstVal) * 100
        let diffValToFixed = diffValPercent.toFixed(2)

        if (diffValToFixed) {
          return diffValToFixed
        }
      }
      return 0
    },
    shareData() {
      if (this.type == "stock") {
        let data = this.$store.getters["stock/getStockShareToFriend"]({
          securityID: this.item.ID
        })
        return data
      } else  {
        return null
      }
    },
    isYearPerfNegative() {
      return Number(this.item.perfYear) < 0
    },
    performanceYearPercentage() {
      if (!isNaN(parseFloat(this.item.perfYear)) && isFinite(this.item.perfYear)) {
        return this.item.perfYear >= 0
          ? "+" + Number(this.item.perfYear).toFixed(2) + " %"
          : Number(this.item.perfYear).toFixed(2) + " %"
      } else {
        return "N/A"
      }
    },
    perfNaN() {
      return !isNaN(parseFloat(this.item.perfYear)) && isFinite(this.item.perfYear) ? false : true
    },
  },
  async mounted() {
    await this.doWatchListProcess()
  },
  async activated() {
    if (this.getIslogin) {
      this.isFollowing = await this.checkAssetInWatchlist({
        subjectType: 'stock',
        id: this.item.ID.toString(),
      })
    }
  },
  deactivated() {
    this.isFollowing = false
  },
  methods: {
    ...mapActions("watchlist", ["checkAssetInWatchlist","updateWatchlist"]),
    ...mapActions("stock", ["findStockShareData"]),
    ...mapActions("indice", ["findIndiceShareData"]),
    resetFact() {
      this.isPrepareCompleted = false
    },
    async generateIndiceTemplate(item) {
      // begin query data
      let obj = {
        stockID: item.ID,
        stockName: item.name,
        period: "3M"
      }
      await this.findIndiceShareData(obj)

      // begin prepare data
      let randomState = Math.floor(Math.random() * 10000000000)
      let prepareData = this.getIndiceShareToFriend

      let perfValuePercent1d = `(${
        prepareData["1D"].percent >= 0 ? "+" + prepareData["1D"].percent + "%" : prepareData["1D"].percent + "%"
      })`
      let perfValueText1d = `${prepareData["1D"].value} ${perfValuePercent1d}`
      let perfValueTextColor1d = `${prepareData["1D"].value >= 0 ? this.colorPlus : this.colorMinus}`

      let cardTitle = item.name ? item.name : ""
      let cardDescription = item.thName ? item.thName : ""
      let cardDate = item.date ? item.date : ""
      let cardValue = this.getIndiceQuote.price ? this.getIndiceQuote.price : ""
      let cardPerfValue1D = perfValueText1d
      let cardPerfValueColor1D = perfValueTextColor1d
      let cardImgUrl = `${process.env.VUE_APP_IMAGE_SERVICE_URL}/graph/stock?name=${item.name}&from=${this.getIndiceTimestamp1D.from}&to=${this.getIndiceTimestamp1D.to}&state=${randomState}`
      let cardImgLinkUrl = `${process.env.VUE_APP_LIFF_LINK}?page=${this.$route.name}&name=${item.name}`
      let cardImgLinkBody = `${process.env.VUE_APP_LIFF_LINK}?page=${this.$route.name}&name=${item.name}`
      let cardPerfValue1M = `${prepareData["1M"].percent ? prepareData["1M"].percent : "-"}`
      let cardPerfValueColor1M = `${prepareData["1M"].percent >= 0 ? this.colorPlus : this.colorMinus}`
      let cardPerfValue3M = `${prepareData["3M"].percent ? prepareData["3M"].percent : "-"}`
      let cardPerfValueColor3M = `${prepareData["3M"].percent >= 0 ? this.colorPlus : this.colorMinus}`
      let cardPerfValue6M = `${prepareData["6M"].percent ? prepareData["6M"].percent : "-"}`
      let cardPerfValueColor6M = `${prepareData["6M"].percent >= 0 ? this.colorPlus : this.colorMinus}`
      let cardPerfValue1Y = `${prepareData["1Y"].percent ? prepareData["1Y"].percent : "-"}`
      let cardPerfValueColor1Y = `${prepareData["1Y"].percent >= 0 ? this.colorPlus : this.colorMinus}`
      let cardCta = `${process.env.VUE_APP_LIFF_LINK}`
      // end prepare data

      // begin replace data
      let templateFex = JSON.stringify(IndiceQuoteTemplate)
      templateFex = templateFex.replace("${card_name_send}", `ข้อมูลดัชนี ${cardTitle}`)
      templateFex = templateFex.replace("${card_title}", cardTitle)
      templateFex = templateFex.replace("${card_description}", cardDescription)
      templateFex = templateFex.replace("${card_value}", cardValue)
      templateFex = templateFex.replace("${card_perf_1d_value}", cardPerfValue1D)
      templateFex = templateFex.replace("${card_perf_1d_value_color}", cardPerfValueColor1D)
      templateFex = templateFex.replace("${card_date}", cardDate)
      templateFex = templateFex.replace("${card_img_url}", cardImgUrl)
      templateFex = templateFex.replace("${card_img_link_url}", cardImgLinkUrl)
      templateFex = templateFex.replace("${card_img_link_body}", cardImgLinkBody)
      templateFex = templateFex.replace("${card_perf_1m_value}", cardPerfValue1M)
      templateFex = templateFex.replace("${card_perf_1m_value_color}", cardPerfValueColor1M)
      templateFex = templateFex.replace("${card_perf_3m_value}", cardPerfValue3M)
      templateFex = templateFex.replace("${card_perf_3m_value_color}", cardPerfValueColor3M)
      templateFex = templateFex.replace("${card_perf_6m_value}", cardPerfValue6M)
      templateFex = templateFex.replace("${card_perf_6m_value_color}", cardPerfValueColor6M)
      templateFex = templateFex.replace("${card_perf_1y_value}", cardPerfValue1Y)
      templateFex = templateFex.replace("${card_perf_1y_value_color}", cardPerfValueColor1Y)
      templateFex = templateFex.replace("${card_btn_url}", cardImgLinkUrl)
      templateFex = templateFex.replace("${card_cta_footer}", cardCta)
      templateFex = templateFex.replace(
        "${card_footer_logo}",
        `${process.env.VUE_APP_SCONTENT_URL}/line-liff/flex/logo-footer.png`
      )
      templateFex = templateFex.replace(
        "${card_footer_link_icon}",
        `${process.env.VUE_APP_SCONTENT_URL}/line-liff/flex/footer-link-icon.png`
      )
      // end replace data
      return JSON.parse(templateFex)
    },
    async generateStockTemplate(item) {
      // begin query data
      let obj = {
        stockID: item.ID,
        stockName: encodeURIComponent(item.name),
        period: "3M",
        type: "price"
      }
      await this.findStockShareData(obj)
      let randomState = Math.floor(Math.random() * 10000000000)
      let shareData = this.shareData
      let perfValue1W = `${this.perfPerPeriod >= 0 ? "+" + this.perfPerPeriod : this.perfPerPeriod}`
      let perfValuePercent1W = `(${
        this.perfPerPeriodPercent >= 0 ? "+" + this.perfPerPeriodPercent + "%" : this.perfPerPeriodPercent + "%"
      })`
      let perfValueText1W = `${perfValue1W} ${perfValuePercent1W}`
      let perfValueTextColor1W = `${perfValue1W >= 0 ? this.colorPlus : this.colorMinus}`
      // end query data

      // begin prepare data in flex messages
      let cardTitle = item.name ? item.name : ""
      let cardDate = item.date ? item.date : ""
      let cardValue = shareData.card_value ? shareData.card_value : ""
      let cardPerfValue1W = perfValueText1W
      let cardPerfValueColor1W = perfValueTextColor1W
      let cardDescription = item.thName ? item.thName : ""
      let closePrice = shareData.card_value ? shareData.card_value : ""
      let dividendValue = shareData.dividend_value ? shareData.dividend_value : ""
      let dividendValueColor = shareData.dividend_value >= 0 ? this.colorPlus : this.colorMinus
      let eps = shareData.eps ? shareData.eps : ""
      let epsGrowth = shareData.eps_growth ? shareData.eps_growth : ""
      let peValue = shareData.pe_value ? shareData.pe_value : ""
      let pbvValue = shareData.pbv_value ? shareData.pbv_value : ""
      let cardImgUrl = `${process.env.VUE_APP_IMAGE_SERVICE_URL}/graph/stock?name=${item.name}&from=${this.getStockTimestamp1D.from}&to=${this.getStockTimestamp1D.to}&state=${randomState}`
      let cardImgLinkUrl = `${process.env.VUE_APP_LIFF_LINK}?page=${this.$route.name}&name=${item.name}`
      let cardCta = `${process.env.VUE_APP_LIFF_LINK}`
      // end prepare data in flex messages

      // begin replace data
      let templateFex = JSON.stringify(StockQuoteTemplate)

      templateFex = templateFex.replace("${card_name_send}", `ข้อมูลหุ้น ${cardTitle}`)
      templateFex = templateFex.replace("${card_title}", cardTitle)
      templateFex = templateFex.replace("${card_date}", cardDate)
      templateFex = templateFex.replace("${card_value}", cardValue)
      templateFex = templateFex.replace("${card_perf_1w_value}", cardPerfValue1W)
      templateFex = templateFex.replace("${card_perf_1w_value_color}", cardPerfValueColor1W)
      templateFex = templateFex.replace("${card_description}", cardDescription)
      templateFex = templateFex.replace("${close_price}", closePrice)
      templateFex = templateFex.replace("${dividend_value}", dividendValue)
      templateFex = templateFex.replace("${dividend_value_color}", dividendValueColor)
      templateFex = templateFex.replace("${eps}", eps)
      templateFex = templateFex.replace("${eps_growth}", epsGrowth)
      templateFex = templateFex.replace("${pe_value}", peValue)
      templateFex = templateFex.replace("${pbv_value}", pbvValue)
      templateFex = templateFex.replace("${card_img_url}", cardImgUrl)
      templateFex = templateFex.replace("${card_img_link_url}", cardImgLinkUrl)
      templateFex = templateFex.replace("${card_btn_url_1}", cardImgLinkUrl)
      templateFex = templateFex.replace("${card_btn_url_2}", cardImgLinkUrl)
      templateFex = templateFex.replace("${card_cta_footer}", cardCta)
      templateFex = templateFex.replace(
        "${card_footer_logo}",
        `${process.env.VUE_APP_SCONTENT_URL}/line-liff/flex/logo-footer.png`
      )
      templateFex = templateFex.replace(
        "${card_footer_link_icon}",
        `${process.env.VUE_APP_SCONTENT_URL}/line-liff/flex/footer-link-icon.png`
      )
      // end replace data
      return JSON.parse(templateFex)
    },
    async generateShareTemplate() {
      this.isPrepareCompleted = false
      const item = this.item

      let templateStr
      if (this.type == "stock") {
        templateStr = await this.generateStockTemplate(item)
      } else if (this.type == "indice") {
        templateStr = await this.generateIndiceTemplate(item)
      }
      this.templateShare = templateStr
      this.isPrepareCompleted = true
    },
    async doWatchListProcess() {
      await new Promise(resolve => setTimeout(resolve, 3000))
      if (!this.getIslogin) {
        return
      }
      this.isFollowing = await this.checkAssetInWatchlist({
        subjectType: 'stock',
        id: this.item.ID.toString(),
      })
      let taskProcess = await this.mixins_get_task("task-after-login")
      if (taskProcess && taskProcess.action == "watchlist") {
        if (taskProcess.criteria && taskProcess.criteria.id == this.item.ID) {
          await this.mixins_delete_task("task-after-login")
          if (!this.isFollowing) {
            await this.watchListProcess()
          }
        }
      }
    },
    async watchListProcess() {
      this.loadingWatchlist = !this.loadingWatchlist
      const action = this.isFollowing ? 'unfollow': 'follow'
      const data = {
        subject_id: this.item.ID.toString()
      }
      this.options.toast.title = action == 'follow' ? [{ success: "ติดตามสำเร็จ", unsuccess: "ติดตามไม่สำเร็จ" }] : [{ success: "เลิกติดตามสำเร็จ", unsuccess: "เลิกติดตามไม่สำเร็จ"}]
      const updateResult = await this.updateWatchlist({ 
        subjectType: 'stock', 
        action: action, 
        payload: data 
      })

      setTimeout(() => {
        this.loadingWatchlist = !this.loadingWatchlist
        if (updateResult) {
          this.isFollowing = !this.isFollowing
        }
        this.toastType = "alert"
        this.toastStatus = updateResult == true
        this.toggleToast = true
      }, 500)
    },
    async addWatchlist() {
      if (!this.getIslogin) {
        let obj = {
          action: "watchlist",
          criteria: {
            name: this.item.name,
            id: this.item.ID
          }
        }
        await this.mixins_set_task("task-after-login", obj)
        this.redirectToAuth()
      } else {
        await this.watchListProcess()
      }
    },
    redirectToAuth() {
      let return_url = `${this.$route.fullPath}`
      window.location.replace(`/login?return_url=${encodeURIComponent(return_url)}`)
    },
    closeToast(bool) {
      this.toggleToast = bool
    }
  }
}
</script>

<style lang="scss" scoped>
.flex-container {
  list-style: none;
  margin: 0 auto;
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  flex-wrap: wrap;

  padding-top: 24px;
  padding-bottom: 24px;
  align-items: center;
  justify-content: center;
}

.quote-detail {
  width: 50%;
  order: 1;
  vertical-align: middle;
  text-align: left;
  line-height: 1.58;
  @include multipleResponsive(mobile, phablet) {
    width: 60%;
    order: 1;
    padding-bottom: 15px;
  }
  h1 {
    @extend %font-size-l;
    color: $color-normal-text;
    margin: 0px;
    font-weight: bold;
    @include multipleResponsive(mobile, phablet) {
      font-size: 18px;
    }
  }
  p {
    color: $color-secondary-text;
    @extend %font-size-ss;
    margin: 0px 0px 10px 0;
    @include multipleResponsive(mobile, phablet) {
      font-size: 12px;
    }
  }
}

.quote-price {
  width: 50%;
  order: 2;
  vertical-align: middle;
  text-align: right;
  padding-right: 24px;
  @include multipleResponsive(mobile, phablet) {
    width: 47%;
    order: 3;
    text-align: center;
    padding-right: 0px;
    border-right: 2px dotted #e9e9e9;
  }
  .h2 {
    @extend %font-size-xl;
    color: $color-normal-text;
    font-weight: bold;
    margin: 0px;
    @include multipleResponsive(mobile, phablet) {
      font-size: 26px;
      height: 35px;
    }
  }
  span {
    @extend %font-size-m;
    color: $color-secondary-text;
    @include multipleResponsive(mobile, phablet) {
      font-size: 12px;
    }
  }
}

.performance-a-year {
  width: 50%;
  order: 3;
  vertical-align: middle;
  text-align: left;
  @include multipleResponsive(mobile, phablet) {
    border-left: 3px dotted #dddddd;
    width: 50%;
    order: 4;
    border: none;
    text-align: center;
  }
  h3 {
    color: $color-normal-text;
    @extend %font-size-s;
    margin: 0px;
    font-weight: normal;
  }
  p {
    margin: 0px;
    font-weight: bold;
    @extend %font-size-s;
  }
  .green {
    color: $color-success;
  }
  .red {
    color: $color-error;
  }
  .grey {
    color: $base-category;
  }
}

.intro-subscriber {
  display: block;
  width: 50%;
  order: 42;
  text-align: right;
  user-select: none;
  @include multipleResponsive(mobile, phablet) {
    width: 40%;
    order: 2;
    padding-bottom: 25px;
    text-align: right;
  }
  .no-event {
    pointer-events: none;
  }
  .share-assets {
    margin-right: 15px;
    vertical-align: middle;
  }
  i {
    color: $color-light-grey-2;
    font-size: 18px;

    font-size: 22px;
  }
  .following {
    color: $color-primary-finno;
    vertical-align: middle;
  }
  .subscribe-btn {
    vertical-align: middle;
    margin-left: 15px;
    i {
      vertical-align: top;
    }
  }
}

.search-loading {
  @extend %container-style;
  text-align: center;
  vertical-align: middle;
  .loading {
    text-align: center;
    font-size: 32px;
    margin: 100px auto auto;
    color: #bababa;
  }
}
</style>